import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AppLayout } from './components/layout/AppLayout';
import LoginPage from './pages/LoginPage';
import SetPasswordPage from './pages/SetPasswordPage';
import GoogleSignIn from './pages/GoogleSignIn';
import ExecutiveDashboard from './pages/ExecutiveDashboard';
import PersonalDashboard from './pages/PersonalDashboard';
import LeaderboardPage from './pages/LeaderboardPage';
import LeadsPage from './pages/LeadsPage';
import PipelinePage from './pages/PipelinePage';
import SalesDashboardPage from './pages/SalesDashboardPage';
import ResourcesPage from './pages/ResourcesPage';
import AssetTrackerPage from './pages/AssetTrackerPage';
import TasksPage from './pages/TasksPage';
import CalendarPage from './pages/CalendarPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ReportsPage from './pages/ReportsPage';
import GoalsPage from './pages/GoalsPage';
import MemberGoalsPage from './pages/MemberGoalsPage';
import AuditLogPage from './pages/AuditLogPage';
import SettingsPage from './pages/SettingsPage';
import AccountPage from './pages/AccountPage';
import BookingSettingsPage from './pages/BookingSettingsPage';
import PublicBookingPage from './pages/PublicBookingPage';
import CommunicationsPage from './pages/CommunicationsPage';
import UnsubscribePage from './pages/UnsubscribePage';
import NotificationsPage from './pages/NotificationsPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="loading">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, isAdmin } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/google-signin" element={<GoogleSignIn />} />
          <Route path="/set-password" element={<SetPasswordPage />} />
          <Route path="/book/:slug" element={<PublicBookingPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<ExecutiveDashboard />} />
            <Route path="/my-dashboard" element={<PersonalDashboard />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/pipeline" element={<PipelinePage />} />
            <Route path="/sales" element={<SalesDashboardPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/assets" element={<AssetTrackerPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/communications" element={<CommunicationsPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/goals" element={<AdminRoute><GoalsPage /></AdminRoute>} />
            <Route path="/member-goals" element={<AdminRoute><MemberGoalsPage /></AdminRoute>} />
            <Route path="/audit-log" element={<AdminRoute><AuditLogPage /></AdminRoute>} />
            <Route path="/settings" element={<AdminRoute><SettingsPage /></AdminRoute>} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/booking" element={<BookingSettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
